export const BASE_ORDERS_QUERY_KEY = "orders"
export const BASE_ORGANIZATIONS_QUERY_KEY = "organizations"

export const BASE_SUMMARY_REPORT_QUERY_KEY = "summaryReport"
export const BASE_TRANSACTION_REPORT_QUERY_KEY =
  "transactionReport"

export const BASE_PRODUCTS_QUERY_KEY = "products"
export const BASE_TRANSACTIONS_QUERY_KEY = "transactions"

export const BASE_PRODUCT_MODIFIERS_QUERY_KEY =
  "productModifiers"
export const BASE_PRODUCT_TAGS_QUERY_KEY = "productTags"
export const BASE_CASHIERS_QUERY_KEY = "cashiers"
export const BASE_CATEGORIES_QUERY_KEY = "categories"

export const BASE_PORTAL_EMAIL_ADDRESSES_QUERY_KEY =
  "portal-email-addresses"

export const NEXT_NOTIFICATION_QUERY_KEY =
  "nextNotification"

export const BASE_Z_REPORTS_QUERY_KEY = "zReports"

export const BASE_TRANSACTIONS_FEED_QUERY_KEY =
  "transactionsFeed"
